import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Button, Size, Type} from '@Components/button';
import styles from './inital-poster-items-load-error-notification.module.scss';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {hideInitalPosterItemsLoadError} from './inital-poster-items-load-error.reducer';

export function InitalPosterItemsLoadErrorNotification(): ReactElement<any> | null {
  const isDisplaying = useAppSelector((state) => {
    return state.initalPosterItemsLoadError.show;
  });
  const dispatch = useAppDispatch();

  const onSave = (): void => {
    dispatch(hideInitalPosterItemsLoadError());
    void window.posterEditor?.whiteboard?.savePoster.save();
  };

  const onRefresh = (): void => {
    window.location.reload();
  };

  if (!isDisplaying) {
    return null;
  }

  const getClasses = (): string => {
    return `flexbox ${styles.container} radius-8 border-s-standard ${isDisplaying ? styles.in : `${styles.out} spacing-p-r-2`}`;
  };

  return (
    <div className={getClasses()}>
      <div className={styles.leftBar} />
      <div className="flex-column-align-center flex-justify-between _full-width">
        <div className="flex-justify-between flex-row-align-center _full-width spacing-p-t-3 spacing-p-r-2 spacing-p-b-4 spacing-p-l-3">
          <div className="flex-v-row spacing-p-t-1 spacing-p-b-0 spacing-p-r-2 spacing-p-l-2">
            <Text bold val={window.i18next.t('pmwjs_item_load_error_heading')} size={TextSize.XSMALL} />
            <Text val={window.i18next.t('pmwjs_item_load_error')} size={TextSize.XSMALL} />
          </div>
        </div>
        <div className={`spacing-p-3 flex-justify-end flex-row-align-center _full-width ${styles.bottomContent}`}>
          <Button customClasses={'spacing-m-r-2'} icon={'icon-refresh'} text={window.i18next.t('pmwjs_refresh')} size={Size.XSMALL} type={Type.SECONDARY} onClick={onRefresh} />
          <Button icon={'icon-save'} text={window.i18next.t('pmwjs_save')} size={Size.XSMALL} type={Type.PRIMARY} onClick={onSave} />
        </div>
      </div>
    </div>
  );
}
